import { useDropzone } from "react-dropzone";
import { UploadCloud, FileCheck2, X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export default function CVDropzone({ file, setFile }) {
  const { t } = useLanguage();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      "application/msword": [".doc"],
    },
    maxFiles: 1,
    maxSize: 10 * 1024 * 1024,
    onDrop: (accepted) => {
      if (accepted && accepted[0]) setFile(accepted[0]);
    },
  });

  if (file) {
    return (
      <div data-testid="cv-selected" className="flex items-center justify-between border border-y5-yellow bg-y5-yellow/5 p-5">
        <div className="flex items-center gap-3">
          <FileCheck2 className="text-y5-yellow" />
          <div>
            <p className="text-white text-sm font-medium">{file.name}</p>
            <p className="text-y5-muted text-xs">{(file.size / 1024).toFixed(0)} Ko</p>
          </div>
        </div>
        <button type="button" data-testid="cv-remove" onClick={() => setFile(null)} className="text-white/50 hover:text-white">
          <X size={20} />
        </button>
      </div>
    );
  }

  return (
    <div {...getRootProps()} data-testid="cv-dropzone" className={`cursor-pointer border border-dashed p-10 text-center transition-all ${isDragActive ? "border-y5-yellow bg-y5-yellow/5" : "border-y5-line hover:border-white/40"}`}>
      <input {...getInputProps()} data-testid="cv-input" />
      <UploadCloud className="mx-auto mb-4 text-y5-yellow" size={32} />
      <p className="text-white font-medium">{t.appForm.dropTitle}</p>
      <p className="text-y5-muted text-sm mt-2">{t.appForm.dropSub}</p>
    </div>
  );
}
